const OptimoveChannelLabel = Object.freeze({
  402: 'Integrations_Optimove_Channel_402',
  461: 'Integrations_Optimove_Channel_461',
  207: 'Integrations_Optimove_Channel_207',
  210: 'Integrations_Optimove_Channel_210',
  509: 'Integrations_Optimove_Channel_509'
})

export { OptimoveChannelLabel }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/optimove/OptimoveChannelEnums.js